import _ from "lodash";

function removeDuplicates(myArr, prop) {
  return myArr.filter((obj, pos, arr) => {
    return arr.map(mapObj => _.get(mapObj, prop)).indexOf(_.get(obj, prop)) === pos;
  });
}

export { removeDuplicates }